import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastModule } from 'primeng/toast';

import { SharedModule } from '@shared/shared.module';
import { LoginBackgroundDesignerComponent } from './components/login-background-designer/login-background-designer.component';
import { TenantCompanyLoginSelectionComponent } from './components/tenant-company-login-selection/tenant-company-login-selection.component';
import { FirstAccessFormComponent } from './first-access-form/first-access-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { PasswordFormComponent } from './password-form/password-form.component';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    PasswordFormComponent,
    FirstAccessFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FormsModule,
    SharedModule,
    ToastModule,
    LoginRoutingModule,
    LoginBackgroundDesignerComponent,
    TenantCompanyLoginSelectionComponent,
  ],
  exports: [LoginFormComponent, PasswordFormComponent, FirstAccessFormComponent],
})
export class LoginModule {}
